import React from "react";
import {
  Button,
  Descriptions,
  Divider,
  Empty,
  Modal,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";

const { Text } = Typography;

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const ReviewOrderModal = ({
  open,
  onCancel,
  onConfirm,
  cart,
  totals,
  formValues,
  loading,
}) => {
  const currency =
    formValues?.currency || "USD";

  const shippingCost = Number(
    formValues?.shippingCost || 0
  );

  const grandTotal =
    totals.subtotal + shippingCost;

  const columns = [
    {
      title: "Part",
      key: "part",
      render: (_, item) => (
        <div>
          <Text strong>
            {item.partName}
          </Text>

          <div>
            <Text type="secondary">
              {item.partNumber}
            </Text>
          </div>
        </div>
      ),
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      width: 90,
    },
    {
      title: "Unit Cost",
      dataIndex: "unitCost",
      width: 120,
      render: (value) =>
        `${currency} ${formatCurrency(value)}`,
    },
    {
      title: "Total",
      key: "total",
      width: 130,
      render: (_, item) =>
        `${currency} ${formatCurrency(
          item.quantity * item.unitCost
        )}`,
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Review Purchase Order"
      width={1100}
      centered
      footer={[
        <Button
          key="cancel"
          onClick={onCancel}
        >
          Edit Order
        </Button>,

        <Button
          key="confirm"
          type="primary"
          loading={loading}
          onClick={onConfirm}
        >
          Create Purchase Order
        </Button>,
      ]}
    >
      <Descriptions
        bordered
        size="small"
        column={{
          xs: 1,
          sm: 2,
          md: 3,
        }}
      >
        <Descriptions.Item label="Supplier">
          {formValues?.supplierName ||
            formValues?.supplierId ||
            "—"}
        </Descriptions.Item>

        <Descriptions.Item label="Order Date">
          {formValues?.orderDate
            ? formValues.orderDate.format(
                "YYYY-MM-DD"
              )
            : "—"}
        </Descriptions.Item>

        <Descriptions.Item label="Currency">
          <Tag color="blue">
            {currency}
          </Tag>
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      {cart.length === 0 ? (
        <Empty description="No items in purchase order" />
      ) : (
        <Table
          rowKey="sparepartId"
          columns={columns}
          dataSource={cart}
          pagination={{
            pageSize: 20,
            showSizeChanger: false,
          }}
          scroll={{
            x: 700,
          }}
          size="small"
        />
      )}

      <Divider />

      <div
        style={{
          maxWidth: 400,
          marginLeft: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 8,
          }}
        >
          <Text>Items</Text>
          <Text strong>
            {totals.itemCount}
          </Text>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 8,
          }}
        >
          <Text>Quantity</Text>
          <Text strong>
            {totals.quantityCount}
          </Text>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 8,
          }}
        >
          <Text>Subtotal</Text>
          <Text strong>
            {currency}{" "}
            {formatCurrency(
              totals.subtotal
            )}
          </Text>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 8,
          }}
        >
          <Text>Shipping</Text>
          <Text strong>
            {currency}{" "}
            {formatCurrency(shippingCost)}
          </Text>
        </div>

        <Divider />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Text strong>
            Grand Total
          </Text>

          <Text
            strong
            style={{
              fontSize: 20,
              color: "#1677ff",
            }}
          >
            {currency}{" "}
            {formatCurrency(grandTotal)}
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export default ReviewOrderModal;